import { lazyLoad } from 'utils/loadable';
import { SplashScreen } from 'app/components/ui/Splash';

export const NotFoundPage = lazyLoad(
  () => import('./index'),
  module => module.NotFoundPage,
  {
    fallback: <SplashScreen />,
  },
);
